// import { useEffect, useState } from "react";
import { PaymentData } from "../../../utils/types";
// import axios from "axios";
// import { PAGE_STEPS } from "../event";
// import { Loading } from "../../../components/loading";

// DEPRECIATED!!

export function EventPaymentScreen({
  paymentData,
  setPageStep,
  handleCancelPayment,
}: {
  paymentData: PaymentData | null;
  setPageStep: (data: string) => void;
  handleCancelPayment: () => void;
}) {
  // DEPRECIATED!!
  // const [loadingPage, setLoadingPage] = useState(true);

  // useEffect(() => {
  //   try {
  //     window.addEventListener(
  //       "message",
  //       function (event) {
  //         if (event.data?.event === "close" || event.data === "close") {
  //           handleCancelPayment();
  //           console.log("call a close function");
  //           return this.window.stop();
  //         }
  //       },
  //       false
  //     );
  //   } catch (error) {
  //     console.log("p-event listener", error);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // useEffect(() => {
  //   setLoadingPage(true);
  //   try {
  //     if (!paymentData?.url) return setLoadingPage(false);

  //     const container = document.getElementById("payment-container");
  //     // Create the iframe element
  //     const iframe = document.createElement("iframe");
  //     // // Set iframe attributes
  //     iframe.src = paymentData.url; // or your dynamic URL
  //     iframe.width = "100%";
  //     iframe.height = "650px";
  //     iframe.id = "payment-iframe";
  //     iframe.style.border = "none";
  //     iframe.allow = "payment";
  //     iframe.allowFullscreen = true;
  //     iframe.remove = () => handleCancelPayment();
  //     iframe.oncancel = () => handleCancelPayment();
  //     iframe.onclose = () => handleCancelPayment();
  //     iframe.onabort = () => handleCancelPayment();
  //     // iframe.sandbox = "allow-same-origin allow-scripts";
  //     // iframe.sandbox = "";

  //     // Append the iframe to the container
  //     if (container) container.appendChild(iframe);
  //     setLoadingPage(false);
  //   } catch (error) {
  //     console.log("attach piframe", error);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [paymentData?.url, handleCancelPayment]);

  // const verifyPayment = async () => {
  //   const {
  //     data: {
  //       data: { status },
  //     },
  //   } = await axios.get(
  //     `https://dingpay-ticket-ms.onrender.com/paystack/verify/${paymentData?.reference}`
  //   );
  //   if (status === "success") setPageStep(PAGE_STEPS.PAYMENT_SUCCESS);
  // };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     verifyPayment();
  //   }, 5000);
  //   return () => clearInterval(interval);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // return (
  //   <div className="payment-container" id="payment-container">
  //     {loadingPage ? <Loading /> : null}
  //   </div>
  // );

  return <></>;
}
